'use client';

import { useEffect } from 'react';
import { onLCP, onINP, onCLS } from 'web-vitals/attribution';
import type { MetricWithAttribution } from 'web-vitals/attribution';
import { WebVitalsReporter } from '../../lib/webVitalsReporter';
const endpoint = process.env.NEXT_PUBLIC_ANALYTICS_ENDPOINT ?? '';
const isProduction = process.env.NEXT_PUBLIC_ENV_NAME === 'production';
const reporter = new WebVitalsReporter({
  endpoint,
  isProduction,
  maxQueueSize: 50
});
export default function WebVitals() {
  useEffect(() => {
    const handleMetric = (metric: MetricWithAttribution) => {
      const captured = reporter.capture(metric as unknown as Parameters<typeof reporter.capture>[0]);
      reporter.report(captured);
    };
    onLCP(handleMetric);
    onINP(handleMetric);
    onCLS(handleMetric);

    // Flush any queued metrics from previous navigations
    reporter.flush();
  }, []);
  return null;
}